import type { ReactNode } from "react"
import StoreProvider from "../StoreProvider"
import AuthWrapper from "./AuthWrapper"
import { ErrorBoundary } from "@/error"
import { UiProvider } from "@/ui"

type Props = {
  children: ReactNode
}

export default function Root({ children }: Props) {
  return (
    <ErrorBoundary>
      <StoreProvider>
        <UiProvider>
          <AuthWrapper>{children}</AuthWrapper>
        </UiProvider>
      </StoreProvider>
    </ErrorBoundary>
  )
}
